import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { ROUTES } from '../../config/routes';
import { toast } from 'react-toastify';
import { parseQueryParams } from '../../utils/utilityFunction';
import { backendBaseUrl } from '../../api/config';
import SuccessToast from '../../@common/SuccessToast/SuccessToast';
import { customToast } from '../../constant/constant';

export const startQuizDetails = createAsyncThunk(
  'quizActivity/startQuizDetails',
  async (param = false, thunkApi) => {
    if (!isNaN(param)) {
      param = {
        quizid: param
      };
    }
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.START_QUIZ_GET_QUESTIONS,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (response?.data?.errorcode) {
        let message = response?.data?.errorcode;
        let headerText = '';
        if (
          message?.includes('require_login_exception') ||
          message?.toLowerCase()?.includes('requireloginerror')
        ) {
          message = 'Complete the previous quiz to unlock it.';
          headerText='Quiz is Locked'
        }
        toast.success(
          <SuccessToast
            headerText={headerText}
            description={message }
            className={'warning'}
          />,
          {
            className: 'Toastify__toast--show',
            onOpen: () => {
              setTimeout(() => {
                document
                  .querySelector('.Toastify__toast--show')
                  .classList.add('Toastify__toast--hide');
              }, 5000);
            },
            onClose: () => {
              const queryParams = parseQueryParams();
              window.location.href = queryParams.moduleId?.length
                ? `${ROUTES.PAGE_ACTIVITY.replace(
                    ':programid',
                    thunkApi.getState().program.currentProgram?.lpid
                  )
                    .replace(':type', 'quiz')
                    .replace(':id', queryParams.moduleId)}?attempt=true`
                : '/';
            }
          }
        );
        return {};
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const postQuestionQuiz = createAsyncThunk(
  'quizActivity/postQuestionQuiz',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param?.params,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.POST_QUESTION_ANSWER,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (!response?.data?.errorcode) {
        if (!param?.params?.finishattempt && !param?.customNavigate) {
          thunkApi.dispatch(
            startQuizDetails(
              param?.quizId || window.location.pathname.split('/').pop()
            )
          );
        } else {
          param.cb();
        }
      } else {
        customToast('Something went wrong', '', 'warning', 5000);
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const BookmarkQuestionQuiz = createAsyncThunk(
  'quizActivity/BookmarkQuestionQuiz',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param.param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.BOOKMARK_QUIZ_QUESTION,
          wstoken: thunkApi.getState().auth.token
        }
      );
      if (!response?.data?.errorcode) {
        thunkApi.dispatch(handleBookmark(param.current));
      } else {
        customToast('Something went wrong', '', 'warning', 5000);
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const ClearSelection = createAsyncThunk(
  'quizActivity/ClearSelection',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.POST_QUESTION_ANSWER,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const QuizReviewDetails = createAsyncThunk(
  'quizActivity/QuizReviewDetails',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_QUESTION_REVIEW,
          wstoken: thunkApi.getState().auth.token
        }
      );
      if (response?.data?.errorcode) {
        toast.success(
          <SuccessToast
            headerText={'Something went wrong'}
            description={response?.data?.message}
            className={'warning'}
          />,
          {
            className: 'Toastify__toast--show',
            onOpen: () => {
              setTimeout(() => {
                document
                  .querySelector('.Toastify__toast--show')
                  .classList.add('Toastify__toast--hide');
              }, 5000);
            },
            onClose: () => {
              const queryParams = parseQueryParams();
              window.location.href = queryParams.moduleId?.length
                ? ROUTES.PAGE_ACTIVITY.replace(
                    ':programid',
                    thunkApi.getState().program.currentProgram?.lpid
                  )
                    .replace(':type', 'quiz')
                    .replace(':id', queryParams.moduleId)
                : '/';
            }
          }
        );
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export async function uploadFilesToServer(quizId, token, files, type = 'quiz') {
  let apiUrl = '';
  if (type === 'quiz') {
    apiUrl = `${backendBaseUrl}/webservice/upload.php?quizid=${quizId}&token=${token}`;
  } else if (type === 'assignment') {
    apiUrl = `${backendBaseUrl}/webservice/upload.php?itemid=${quizId}&token=${token}&filearea=draft`;
  }

  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`userdata${index + 1}`, file);
  });

  formData.append('filepath', '/');

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
      // Handle success
    } else {
      return response.statusText;
      // Handle error
    }
  } catch (error) {
    console.error('Upload error:', error.message);
    // Handle error
  }
}

export const quizActivitySlice = createSlice({
  name: 'quizActivity',
  initialState: {
    loading: false,
    quizLoading: false,
    submitQuestionLoading: false,
    quizQuestionDetails: {},
    quizDetails: {},
    quizReviewLoading: {},
    quizReviewDetails: {}
  },
  reducers: {
    resetState: (state, action) => {
      state.quizQuestionDetails = {};
    },
    handleBookmark: (state, action) => {
      const { payload: questionIndex } = action;

      const newQuizQuestionDetails = { ...state.quizQuestionDetails };

      const newQuestions = [...newQuizQuestionDetails.questions];

      const newQuestion = { ...newQuestions[questionIndex] };

      newQuestion.flagged = !newQuestion.flagged;

      newQuestions[questionIndex] = newQuestion;

      newQuizQuestionDetails.questions = newQuestions;

      state.quizQuestionDetails = newQuizQuestionDetails;
    },
    handleClear: (state, action) => {
      const { payload: questionIndex } = action;

      const newQuizQuestionDetails = { ...state.quizQuestionDetails };

      const newQuestions = [...newQuizQuestionDetails.questions];

      const newQuestion = { ...newQuestions[questionIndex] };

      newQuestion.userresponse = JSON.stringify('{}');

      newQuestions[questionIndex] = newQuestion;

      newQuizQuestionDetails.questions = newQuestions;

      state.quizQuestionDetails = newQuizQuestionDetails;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(startQuizDetails.pending, (state) => {
      state.quizLoading = true;
    });
    builder.addCase(startQuizDetails.fulfilled, (state, action) => {
      state.quizLoading = false;
      state.quizQuestionDetails = action?.payload || {};
    });
    builder.addCase(startQuizDetails.rejected, (state) => {
      state.quizLoading = false;
      state.quizQuestionDetails = {};
    });
    builder.addCase(postQuestionQuiz.pending, (state) => {
      state.submitQuestionLoading = true;
    });
    builder.addCase(postQuestionQuiz.fulfilled, (state, action) => {
      state.submitQuestionLoading = false;
    });
    builder.addCase(postQuestionQuiz.rejected, (state) => {
      state.submitQuestionLoading = false;
    });
    builder.addCase(QuizReviewDetails.pending, (state) => {
      state.quizReviewLoading = true;
    });
    builder.addCase(QuizReviewDetails.fulfilled, (state, action) => {
      state.quizReviewLoading = false;
      state.quizReviewDetails = action?.payload || {};
    });
    builder.addCase(QuizReviewDetails.rejected, (state) => {
      state.quizReviewLoading = false;
    });
  }
});

export const { handleBookmark, resetState } = quizActivitySlice.actions;

export default quizActivitySlice.reducer;
